<template>
    <div 
        class="image" 
        :class="[{'validate-error':!validateResult}, align]" 
        @click="imgClickHandle"
    >
        <img :src="value" :name="field" :style="{height:height+'px'}"/>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
        propValue: String
    },

    data() {
        return {
            validateResult: true,
            value: this.propValue,
            field: this.options.field,
            height: this.options.height,
            align: this.options.align // 排列方式 left/center/right
        };
    },

    watch: {
        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        imgClickHandle() {
            this.options.onClick && this.options.onClick(this);
        }
    }
};
</script>

<style scoped>
.image {
    width: 100%;
    min-height: 50px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
}

.text-input.validate-error {
    border-color: #ff6e6e;
}

.image.left {
    text-align: left;
}

.image.center {
    text-align: center;
}

.image.right {
    text-align: right;
}
</style>